import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BadgeCheck, CircleAlert } from "lucide-react";
import { AuthShell } from "../components/AuthShell";
import { publicApi, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading" });
  const { parent, refreshParent } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    publicApi.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => { setState({ status: "ok" }); refreshParent(); })
      .catch((e) => setState({ status: "error", msg: e?.response?.status === 422 ? "This link is invalid or has expired. Please request a new one." : errMsg(e) }));
  }, [params, refreshParent]);

  return (
    <AuthShell testid={`verify-${state.status}`}>
      {state.status === "loading" && <p className="font-display text-xl">Confirming your email…</p>}
      {state.status === "ok" && (
        <>
          <BadgeCheck size={48} className="text-[#22A06B]" />
          <h1 className="text-3xl font-bold">Email confirmed!</h1>
          <p className="text-[#1B1A2E]/75">Thanks! You'll now get important updates about your family account.</p>
          <Link to={parent ? "/profiles" : "/login"} data-testid="verify-continue-btn" className="zn-btn bg-[#FF6B4A] text-white w-full">Continue to Zunii</Link>
        </>
      )}
      {state.status === "error" && (
        <>
          <CircleAlert size={44} className="text-[#E8442A]" />
          <h1 className="text-3xl font-bold">Hmm, that didn't work</h1>
          <p data-testid="verify-error-msg">{state.msg}</p>
          <p className="text-sm text-[#1B1A2E]/70">You can send a new link from Parent zone → Account.</p>
          <Link to={parent ? "/profiles" : "/login"} className="zn-btn bg-white w-full">Back to Zunii</Link>
        </>
      )}
    </AuthShell>
  );
}
